export type ActionKind = 'service' | 'inspection' | 'leasing' | 'tax';

export interface ActionCounts {
  kind: ActionKind;
  total: number;
  overdue: number;
  soon: number;
  assigned: number;
}

export type ActionChip = 'overdue' | 'soon' | 'assigned';

/** Service öppnar servicemodulen. Övriga rader öppnar listan där bilen går att nå. */
export function actionDetailTarget(kind: ActionKind): 'service' | 'list' {
  return kind === 'service' ? 'service' : 'list';
}
export type ActionBarTone = 'overdue' | 'assigned' | 'none';

/** Förfallna först. Lika många förfallna sorteras efter totalen. */
export function sortActionRows(rows: ActionCounts[]): ActionCounts[] {
  return [...rows].sort((a, b) => b.overdue - a.overdue || b.total - a.total);
}

export function actionChips(row: Pick<ActionCounts, 'overdue' | 'soon' | 'assigned'>): ActionChip[] {
  const chips: ActionChip[] = [];
  if (row.overdue > 0) chips.push('overdue');
  if (row.soon > 0) chips.push('soon');
  if (row.assigned > 0) chips.push('assigned');
  return chips;
}

/** Röd stapel är förfallna. Saknas de färgas tilldelade. Resten av stapeln är horisonten. */
export function actionBarShare(row: Pick<ActionCounts, 'total' | 'overdue' | 'assigned'>): {
  tone: ActionBarTone;
  ratio: number;
} {
  if (row.total <= 0) return { tone: 'none', ratio: 0 };
  if (row.overdue > 0) return { tone: 'overdue', ratio: Math.min(1, row.overdue / row.total) };
  if (row.assigned > 0) return { tone: 'assigned', ratio: Math.min(1, row.assigned / row.total) };
  return { tone: 'none', ratio: 0 };
}
